export function isWebview(): boolean {
	if (typeof window === 'undefined') return false;

	const ua = navigator.userAgent || '';
	return (
		/wv|WebView|Android.*Version\/[\d.]+.*Chrome\/[\d.]+ Mobile|; wv\)/.test(ua) ||
		/FBAN|FBAV|Instagram|Twitter|Line\/|GSA\//.test(ua) ||
		(window as any).ReactNativeWebView !== undefined
	);
}
